<template>
  <b-modal id="payment-gateway-balance-modal" :title="`ปรับยอดเครดิต${paymentGatewayInfo ? `: ${paymentGatewayInfo.name}` : ''}`" hide-footer @hidden="resetForm">
    <ValidationObserver v-slot="{ handleSubmit }" ref="balanceForm">
      <b-form @submit.prevent="handleSubmit(onSubmit)">
        <b-form-group label="ยอดคงเหลือปัจจุบัน">
          <b-form-input :value="currentBalanceText" disabled />
        </b-form-group>

        <b-form-group label="ประเภทการปรับยอด">
          <b-form-radio-group v-model="form.type" button-variant="light" buttons class="d-flex">
            <b-form-radio :button-variant="form.type === 'increase' ? 'outline-success' : ''" value="increase">
              เพิ่ม
            </b-form-radio>
            <b-form-radio :button-variant="form.type === 'decrease' ? 'outline-danger' : ''" value="decrease">
              ลด
            </b-form-radio>
            <b-form-radio :button-variant="form.type === 'set' ? 'outline-primary' : ''" value="set">
              ปรับยอด
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>

        <ValidationProvider v-slot="{ errors }" :rules="amountRules" name="จำนวน">
          <b-form-group :description="amountDescription" label="จำนวน (บาท) *">
            <b-form-input
                v-model="form.amount"
                :state="errors[0] ? false : null"
                name="amount"
                step="any"
                type="number"
            />
            <b-form-invalid-feedback>
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>

        <ValidationProvider v-slot="{ errors }" name="หมายเหตุ" rules="max:255">
          <b-form-group description="บันทึกลงประวัติการทำรายการ" label="หมายเหตุ">
            <b-form-textarea
                v-model="form.remark"
                :state="errors[0] ? false : null"
                max-rows="4"
                maxlength="255"
                name="remark"
                rows="2"
            />
            <b-form-invalid-feedback>
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>

        <div class="text-right">
          <b-button class="mr-2" type="button" variant="secondary" @click="$bvModal.hide('payment-gateway-balance-modal')">
            ยกเลิก
          </b-button>
          <b-button :disabled="isSubmitting" type="submit" variant="primary">
            บันทึก
          </b-button>
        </div>
      </b-form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import {mapActions} from 'vuex';
import {PAYMENT_GATEWAY} from '@src/constants/payment-gateway';

export default {
  name: 'PaymentGatewayBalanceModal',
  props: {
    // { id, name, balance } ของเจ้าที่กำลังปรับยอด
    gateway: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
      form: {
        type: 'increase',
        amount: '',
        remark: ''
      },
      isSubmitting: false,
    }
  },
  computed: {
    paymentGatewayInfo() {
      return this.gateway?.name ? PAYMENT_GATEWAY[this.gateway.name] : null
    },
    currentBalanceText() {
      return `${Number(this.gateway?.balance ?? 0).toLocaleString()} บาท`
    },
    // ปรับยอดตั้งเป็น 0 ได้ แต่เพิ่ม/ลดต้องมากกว่า 0
    amountRules() {
      return this.form.type === 'set' ? 'required|min_value:0' : 'required|min_value:1'
    },
    amountDescription() {
      switch (this.form.type) {
        case 'increase':
          return 'จำนวนที่ต้องการเพิ่มเข้ายอดคงเหลือ'
        case 'decrease':
          return 'จำนวนที่ต้องการหักออกจากยอดคงเหลือ'
        default:
          return 'ยอดคงเหลือใหม่หลังปรับยอด'
      }
    }
  },
  methods: {
    ...mapActions(['updatePaymentGatewayBalance']),
    resetForm() {
      this.form = {
        type: 'increase',
        amount: '',
        remark: ''
      }
      this.$refs.balanceForm?.reset()
    },
    async onSubmit() {
      if (!this.gateway?.id) return
      this.isSubmitting = true
      const isUpdated = await this.updatePaymentGatewayBalance({
        id: this.gateway.id,
        data: {
          amount: Number(this.form.amount),
          type: this.form.type,
          ...(this.form.remark ? { remark: this.form.remark } : {})
        }
      })
      if (isUpdated) {
        this.$bvModal.hide('payment-gateway-balance-modal')
        this.$emit('onUpdate')
      }
      this.isSubmitting = false
    }
  }
}
</script>
